/* eslint-disable react/destructuring-assignment */
import isEmpty from "lodash-es/isEmpty"
import map from "lodash-es/map"

import {
    reflectionBaseAdapter,
    selfAssessmentAnswerBaseAdapter,
    selfAssessmentQuestionAdapter,
    selfAssessmentSummaryAdapter
} from "@/3514/adapters"
import type {
    ISelfDiagnosticSummaryBaseDto as ISelfAssessmentSummaryDto,
    ISelfDiagnosticSummaryBaseModel as ISelfAssessmentSummaryModel
} from "@/3514/types"

import type {
    IDiagnosticSummaryDiagnosticAnswerDto as IDiagnosticAnswerDto,
    IDiagnosticSummaryDiagnosticAnswerModel as IDiagnosticAnswerModel,
    IDiagnosticSummaryDiagnosticDto as IDiagnosticDto,
    IDiagnosticSummaryDiagnosticModel as IDiagnosticModel,
    IDiagnosticSummaryDiagnosticQuestionDto as IDiagnosticQuestionDto,
    IDiagnosticSummaryDiagnosticQuestionModel as IDiagnosticQuestionModel,
    IDiagnosticSummaryQueryDto as IQueryDto,
    IDiagnosticSummaryQueryModel as IQueryModel,
    IDiagnosticSummaryReflectionAnswerDto as IReflectionAnswerDto,
    IDiagnosticSummaryReflectionAnswerModel as IReflectionAnswerModel,
    IDiagnosticSummaryReflectionDto as IReflectionDto,
    IDiagnosticSummaryReflectionModel as IReflectionModel,
    IDiagnosticSummarySummaryDto as ISummaryDto,
    IDiagnosticSummarySummaryModel as ISummaryModel,
    IDiagnosticSummarySummaryModuleDto as ISummaryModuleDto,
    IDiagnosticSummarySummaryModuleModel as ISummaryModuleModel
} from "./diagnostic-summary.api.types"

export default (dto: IQueryDto): IQueryModel =>
    isEmpty(dto)
        ? null
        : {
              diagnostics: isEmpty(dto.pre_program_diagnostic)
                  ? []
                  : map<IDiagnosticDto, IDiagnosticModel>(
                        dto.pre_program_diagnostic,
                        (d: IDiagnosticDto): IDiagnosticModel => ({
                            answers: isEmpty(d.answer_data)
                                ? []
                                : map<IDiagnosticAnswerDto, IDiagnosticAnswerModel>(
                                      d.answer_data,
                                      (a: IDiagnosticAnswerDto): IDiagnosticAnswerModel => ({
                                          ...selfAssessmentAnswerBaseAdapter(a),
                                          question: a.question,
                                          rank: a.rank
                                      })
                                  ),
                            summaries: isEmpty(d.summary_list)
                                ? []
                                : map<ISelfAssessmentSummaryDto, ISelfAssessmentSummaryModel>(
                                      d.summary_list,
                                      selfAssessmentSummaryAdapter
                                  ),
                            questions: isEmpty(d.question_list)
                                ? []
                                : map<IDiagnosticQuestionDto, IDiagnosticQuestionModel>(
                                      d.question_list,
                                      (q: IDiagnosticQuestionDto): IDiagnosticQuestionModel => ({
                                          ...selfAssessmentQuestionAdapter(q),
                                          content: q.content
                                      })
                                  ),
                            module: isEmpty(d.module) ? null : { id: d.module.id, title: d.module.title_data },
                            type: d.type
                        })
                    ),
              reflections: isEmpty(dto.reflection_objective_question)
                  ? []
                  : map<IReflectionDto, IReflectionModel>(
                        dto.reflection_objective_question,
                        (question: IReflectionDto): IReflectionModel => ({
                            answers: isEmpty(question.answer_data)
                                ? []
                                : map<IReflectionAnswerDto, IReflectionAnswerModel>(
                                      question.answer_data,
                                      (a: IReflectionAnswerDto): IReflectionAnswerModel => ({
                                          answer: a.answer,
                                          rank: a.rank,
                                          questionUuid: a.question_uuid
                                      })
                                  ),
                            questions: isEmpty(question.question_list)
                                ? []
                                : map(question.question_list, reflectionBaseAdapter),
                            type: question.type
                        })
                    ),
              summaries: isEmpty(dto.summary)
                  ? []
                  : map<ISummaryDto, ISummaryModel>(
                        dto.summary,
                        (s: ISummaryDto): ISummaryModel => ({
                            category: {
                                description: s.category.description,
                                id: s.category.id,
                                name: s.category.name
                            },
                            modules: isEmpty(s.modules)
                                ? []
                                : map<ISummaryModuleDto, ISummaryModuleModel>(
                                      s.modules,
                                      (m: ISummaryModuleDto): ISummaryModuleModel => ({
                                          id: m.id,
                                          longDescription: m.long_description,
                                          maxRank: m.max_rank,
                                          rank: m.rank,
                                          shortDescription: m.short_description,
                                          summary: selfAssessmentSummaryAdapter(m.summary),
                                          title: m.title
                                      })
                                  )
                        })
                    )
          }
